import { compose, hoistStatics, withHandlers, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import UserService from '../../../services/user.service';
import NewMessageToast from './NewMessageToast';
import { messageActions } from '../../../reducers/messages';

const displayMessage = ({ channel_id, setNewMessage }) => (e) => {
  e.preventDefault();
  toast.dismiss();
  setNewMessage({ id: channel_id });
};

const mapDispatchToProps = ({
  setNewMessage: messageActions.setNewMessage,
});

const enhance = compose(
  connect(null, mapDispatchToProps),
  translate('portal'),
  withProps(props => ({
    username: UserService.getUserName({ t: props.t, user: props.user }),
    userAvatar: UserService.getAvatar({ ...props.user }, 150, 150, true),
  })),
  withHandlers({
    displayMessage,
  }),
);

export default withRouter(hoistStatics(enhance)(NewMessageToast));



// WEBPACK FOOTER //
// ./src/components/modules/newMessageToast/index.js